import _ from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./TimeRange.scss";

import { ButtonDisclosure, TimePicker } from "@toddle-edu/ds-web";
import { ClockOutlined } from "@toddle-edu/ds-icons";

const styles = {
  timeSelectorStyles: { width: "616px" },
};

export const TimeRangePicker = ({ disabled, field, isTimeSelector }) => {
  const { t } = useTranslation(["unitPlan", "common"]);

  if (isTimeSelector) {
    return (
      <div
        style={styles.timeSelectorStyles}
        data-test-id={`routine-templates-timerange-selector`}
      >
        <TimePicker
          disabled={disabled}
          dsVersion="2.0"
          picker={"time"}
          size="medium"
          value={null}
          placeholder={_.get(field, "placeholder", t("journal:select_a_time"))}
          testId="routine-templates-timerange-picker"
        >
          <ButtonDisclosure
            isFullWidth={true}
            dsVersion="2.0"
            icon={<ClockOutlined variant="subtle" />}
            variant="neutral"
            type="outlined"
            testId="routine-templates-timerange-button"
          >
            <label
              className={classes.label}
              data-test-id="routine-templates-timerange-label"
            >
              {_.get(field, "placeholder", t("journal:select_a_time"))}
            </label>
          </ButtonDisclosure>
        </TimePicker>
      </div>
    );
  }
  return (
    <div
      className={classes.timePickerContainer}
      data-test-id="routine-templates-timerange-container"
    >
      <div
        className={classes.timePickerWrapper}
        data-test-id="routine-templates-timerange-startwrapper"
      >
        <TimePicker
          disabled={disabled}
          dsVersion="2.0"
          label={t("common:start_time_label")}
          picker={"time"}
          size="medium"
          placeholder={_.get(
            field,
            "metadata.startTimePlaceholder",
            t("journal:select_a_time")
          )}
          value={null}
          testId="routine-templates-timerange-starttime"
        >
          <ButtonDisclosure
            isFullWidth={true}
            dsVersion="2.0"
            icon={<ClockOutlined variant="subtle" />}
            variant="neutral"
            type="outlined"
            testId="routine-templates-timerange-start"
          >
            <label
              className={classes.label}
              data-test-id="routine-templates-timerange-startlabel"
            >
              {_.get(
                field,
                "metadata.startTimePlaceholder",
                t("journal:select_a_time")
              )}
            </label>
          </ButtonDisclosure>
        </TimePicker>
      </div>
      <div
        className={classes.timePickerWrapper}
        data-test-id="routine-templates-timerange-endwrapper"
      >
        <TimePicker
          disabled={disabled}
          dsVersion="2.0"
          label={t("common:end_time_label")}
          picker={"time"}
          size="medium"
          placeholder={_.get(
            field,
            "metadata.endTimePlaceholder",
            t("journal:select_a_time")
          )}
          value={null}
          testId="routine-templates-timerange-endtime"
        >
          <ButtonDisclosure
            isFullWidth={true}
            dsVersion="2.0"
            icon={<ClockOutlined variant="subtle" />}
            variant="neutral"
            type="outlined"
            testId="routine-templates-timerange-end"
          >
            <label
              className={classes.label}
              data-test-id="routine-templates-timerange-endlabel"
            >
              {_.get(
                field,
                "metadata.endTimePlaceholder",
                t("journal:select_a_time")
              )}
            </label>
          </ButtonDisclosure>
        </TimePicker>
      </div>
    </div>
  );
};

export default TimeRangePicker;
